import React from 'react';
import { Redirect } from 'react-router-dom';
import CreateEdit from '../views/createEdit';
import Layout from "./Layout";

class Create extends React.Component {

    render() {
        const isAlreadyAuthenticated = localStorage.getItem('token');
        return (
            <Layout>
            <div className="create-edit-blk">
                {isAlreadyAuthenticated ? <CreateEdit />: (
                    <Redirect to={{ pathname: '/asd-login' }}/>
                )}
            </div>
            </Layout>
        );
    }
}

export default Create;